import JsonType from "@viewStore/JsonType"
import { flow, types } from "mobx-state-tree"
import StringMask from "string-mask"
import StateStore from "../../store/StateStore/StateStore"
import api from "./service"

const GridStore = types
    .model({
        state: types.enumeration("State", ["pending", "done", "error"]),
        stateMessage: types.optional(types.string, ""),

        competencia: types.optional(types.string, ''),
        status_remessa: types.optional(types.string, ''),
        retificado: types.optional(types.string, ''),
        origem: types.maybe(JsonType, []),
        decreto: types.maybe(JsonType, []),
        origemSelect: types.optional(JsonType, []),
        decretoSelect: types.optional(JsonType, []),

        rowsCount: types.optional(types.integer, 0),
        page: types.optional(types.integer, 1),
        limit: types.optional(types.integer, 30),
        offset: types.optional(types.integer, 0),
        rows: types.optional(JsonType, [])
    })
    .views(self => {
        return {
            get getRows() {
                const rows = []
                Object.entries(self.rows).forEach(([competencia, origens]) => {
                    Object.entries(origens).forEach(([nome, lancamentos]) => {
                        const origemID = lancamentos[0].lotacao.origem.id
                        rows.push({ competencia, nome, lancamentos, origemID })
                    })
                })
                return rows
            },

            get getCompetencia() {
                return StringMask.apply(self.competencia, '####/##')
            }
        }
    })
    .actions(self => ({

        onChangeCompetencia(value) {
            self.competencia = value.replace(/[^0-9]/g, '')
        },

        onChangeOrigem(origem) {
            self.origem = origem
        },

        onChangeDecreto(decreto) {
            self.decreto = decreto
        },

        setOrigensSelect(origens) {
            self.origemSelect = origens
        },

        setDecretoSelect(decretos) {
            self.decretoSelect = decretos
        },

        onChangeStatusRemessa(value) {
            self.status_remessa = value
        },

        onChangeRetificado(value) {
            self.retificado = value
        },

        onChangePage(value) {
            self.page = value
        },

        onChangeOffset(value) {
            self.offset = value
        },

        clearState() {
            self.state = 'done'
            self.stateMessage = ''
            // self.competencia = ''
            // self.origem = []
            // self.status_remessa = ''
        },

        clearStateMessage() {
            self.stateMessage = ""
        },

        fetchRows: flow(function* fetchRows() {
            self.rows = []
            self.state = "pending"
            try {

                const search = {
                    competencia: self.competencia,
                    retificado: self.retificado,
                    origem_id: self.origem?.value,
                    decreto_id: self.decreto?.value,
                    status_remessa: self.status_remessa,
                    page: self.page,
                    limit: self.limit,
                    offset: self.offset
                }

                api._token = StateStore.apiToken
                const json = yield api.fetch(search)
                if (json.hasOwnProperty('data')) {
                    self.rows = json.data.rows
                    self.rowsCount = json.data.total
                }
                self.state = "done"
            } catch (error) {
                self.state = "error"
                self.stateMessage = error.message
            }
        }),

        delete: flow(function* deleteRow(id) {
            self.state = "pending"
            try {
                api._token = StateStore.apiToken
                const json = yield api.delete(id)

                self.state = "done"
                self.stateMessage = json.message
                self.fetchRows()
            } catch (error) {
                self.state = "error"
                self.stateMessage = error.message
            }
        })
    }))

export default GridStore.create({ state: 'done' })